export default __webpack_public_path__ + "static/media/undraw_medicine_b-1-ol.9d500013.svg";